import { isOfType } from '../../../../ts-utils';
export const LIVE_COMMENTS_RECEIVED = 'LIVE_COMMENTS_RECEIVED';
export const liveCommentsReceived = (payload) => ({
    type: LIVE_COMMENTS_RECEIVED,
    payload,
});
export const REVEAL_LIVE_COMMENTS = 'REVEAL_LIVE_COMMENTS';
export const revealLiveComments = (payload) => ({
    type: REVEAL_LIVE_COMMENTS,
    payload,
});
export const FETCH_LIVE_COMMENTS_SUCCESS = 'FETCH_LIVE_COMMENTS_SUCCESS';
export const FETCH_LIVE_COMMENTS_FAILURE = 'FETCH_LIVE_COMMENTS_FAILURE';
export const FETCH_LIVE_COMMENTS_NOT_FOUND = 'FETCH_LIVE_COMMENTS_NOT_FOUND';
export const fetchLiveCommentsSuccess = (payload) => ({
    type: FETCH_LIVE_COMMENTS_SUCCESS,
    payload,
});
export const fetchLiveCommentsFailure = (payload) => ({
    type: FETCH_LIVE_COMMENTS_FAILURE,
    payload,
});
export const fetchLiveCommentsNotFound = (payload) => ({
    type: FETCH_LIVE_COMMENTS_NOT_FOUND,
    payload,
});
export const REVEAL_LIVE_REPLIES = 'REVEAL_LIVE_REPLIES';
export const revealLiveReplies = (payload) => ({
    type: REVEAL_LIVE_REPLIES,
    payload,
});
export const SOMEONE_IS_TYPING = 'SOMEONE_IS_TYPING';
export const someoneIsTyping = (payload) => ({
    type: SOMEONE_IS_TYPING,
    payload,
});
export const I_AM_TYPING = 'I_AM_TYPING';
export const iAmTyping = (payload) => ({
    type: I_AM_TYPING,
    payload,
});
export const isLiveUpdatesAction = isOfType([
    REVEAL_LIVE_COMMENTS,
    REVEAL_LIVE_REPLIES,
    FETCH_LIVE_COMMENTS_SUCCESS,
    FETCH_LIVE_COMMENTS_FAILURE,
    FETCH_LIVE_COMMENTS_NOT_FOUND,
    LIVE_COMMENTS_RECEIVED,
    SOMEONE_IS_TYPING,
    I_AM_TYPING,
]);
//# sourceMappingURL=live-updates-actions.js.map